import state from '../../state'

/**
 * Calls the sdk manager store method having the given name with the given payload.
 *
 * @param {Object} param
 * @param {String} param.method - sdk manager store method name
 * @param {Object} param.payload - payload to invoke method with
 * @returns {*}
 */
export default function handleSrciStateRequest ({ data }) {
  return state.aggregator.store[data.method](...data.payload)
}
